import { adjustActionCardForPrompt } from '../../utils/ai/adjustActionCardForPrompt'
import { getSectionsToBeAnswered } from '../../utils/ai/getSectionsToBeAnswered'
import type { GeneratedPlayResponse, BackendClient } from '@playbooks/core/src/services/BackendClient'
import type { ActionCard, AiPlayContextParams } from '@playbooks/core/src/interfaces'

interface GenerateResponsesOptions extends AiPlayContextParams {
  playbooksBackendClient: BackendClient
  prompt: string
  actionCardsData: ActionCard
  currentDate?: string
  fileIds?: string[]
  includeAiScope?: boolean
}

/**
 * Generate Action Card responses using LLM and the provided prompt.
 */
export default async function generateResponses({
  playbooksBackendClient,
  prompt,
  actionCardsData,
  currentDate,
  playId,
  playSource,
  templateId,
  fileIds,
  includeAiScope,
}: GenerateResponsesOptions): Promise<GeneratedPlayResponse[]> {
  // Generate text with the AI model
  return await playbooksBackendClient.generatePlayResponses({
    prompt,
    actionCard: JSON.stringify({ sections: getSectionsToBeAnswered(actionCardsData, true) }),
    knowledge: JSON.stringify(adjustActionCardForPrompt(actionCardsData.sections)),
    currentDate,
    playId,
    playSource,
    templateId,
    fileIds,
    includeAiScope,
  })
}
